// extracted by mini-css-extract-plugin
export default {"carousel":"SKI5MWQX","strip":"_2KjbHP1q","carouselSmall":"_1SdOS-Fq"};